import { jsxs, jsx } from "react/jsx-runtime";
const DevOptionsPanel = ({
  isDevMode,
  devOptionsExpanded,
  setDevOptionsExpanded,
  useTextRecall,
  setUseTextRecall,
  pageSize,
  setPageSize,
  rankingWeights,
  handleWeightChange
}) => {
  if (!isDevMode) return null;
  return /* @__PURE__ */ jsxs("div", { style: { borderBottom: "1px solid #e5e7eb", flexShrink: 0 }, children: [
    /* @__PURE__ */ jsxs(
      "button",
      {
        onClick: () => setDevOptionsExpanded((prev) => !prev),
        style: {
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          padding: "6px 16px",
          background: "#fefce8",
          border: "none",
          cursor: "pointer",
          fontSize: "13px",
          color: "#92400e",
          fontWeight: 500
        },
        children: [
          /* @__PURE__ */ jsx("span", { children: "Dev Options" }),
          /* @__PURE__ */ jsx("span", { style: { fontSize: "12px" }, children: devOptionsExpanded ? "▲" : "▼" })
        ]
      }
    ),
    devOptionsExpanded && /* @__PURE__ */ jsxs(
      "div",
      {
        style: {
          padding: "12px 16px",
          fontSize: "13px",
          color: "#555",
          display: "flex",
          flexDirection: "column",
          gap: "14px",
          background: "#fffef5"
        },
        children: [
          /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center", gap: "24px", flexWrap: "wrap" }, children: [
            /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center", gap: "8px" }, children: [
              /* @__PURE__ */ jsx("span", { style: { color: "#555", fontWeight: 500 }, children: "Recall:" }),
              /* @__PURE__ */ jsx(
                "button",
                {
                  onClick: () => setUseTextRecall(true),
                  style: {
                    padding: "4px 14px",
                    borderRadius: "6px",
                    border: "1px solid",
                    borderColor: useTextRecall ? "#2563eb" : "#d1d5db",
                    backgroundColor: useTextRecall ? "#eff6ff" : "transparent",
                    color: useTextRecall ? "#2563eb" : "#6b7280",
                    cursor: "pointer",
                    fontSize: "13px",
                    fontWeight: useTextRecall ? 600 : 400
                  },
                  children: "Text"
                }
              ),
              /* @__PURE__ */ jsx(
                "button",
                {
                  onClick: () => setUseTextRecall(false),
                  style: {
                    padding: "4px 14px",
                    borderRadius: "6px",
                    border: "1px solid",
                    borderColor: !useTextRecall ? "#2563eb" : "#d1d5db",
                    backgroundColor: !useTextRecall ? "#eff6ff" : "transparent",
                    color: !useTextRecall ? "#2563eb" : "#6b7280",
                    cursor: "pointer",
                    fontSize: "13px",
                    fontWeight: !useTextRecall ? 600 : 400
                  },
                  children: "KNN"
                }
              )
            ] }),
            /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center", gap: "8px" }, children: [
              /* @__PURE__ */ jsx("span", { style: { color: "#555", fontWeight: 500 }, children: "Page size:" }),
              /* @__PURE__ */ jsx(
                "input",
                {
                  type: "number",
                  value: pageSize,
                  onChange: (e) => setPageSize(Math.max(1, Math.min(200, parseInt(e.target.value) || 20))),
                  style: {
                    width: "72px",
                    padding: "4px 8px",
                    borderRadius: "6px",
                    border: "1px solid #d1d5db",
                    fontSize: "13px",
                    textAlign: "center"
                  }
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ jsxs("div", { style: { display: "flex", flexDirection: "column", gap: "8px" }, children: [
            /* @__PURE__ */ jsxs("span", { style: { color: "#555", fontWeight: 500 }, children: [
              "Ranking weights",
              " ",
              /* @__PURE__ */ jsxs("span", { style: { fontWeight: 400, color: "#999" }, children: [
                "(total: ",
                Object.values(rankingWeights).reduce((s, v) => s + v, 0).toFixed(2),
                ")"
              ] })
            ] }),
            Object.keys(rankingWeights).map((key) => /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center", gap: "10px" }, children: [
              /* @__PURE__ */ jsx("span", { style: { minWidth: "70px", color: "#666", fontSize: "13px" }, children: key.replace("Weight", "") }),
              /* @__PURE__ */ jsx(
                "input",
                {
                  type: "range",
                  min: "0",
                  max: "1",
                  step: "0.01",
                  value: rankingWeights[key],
                  onChange: (e) => handleWeightChange(key, parseFloat(e.target.value)),
                  style: { flex: 1, accentColor: "#2563eb", cursor: "pointer" }
                }
              ),
              /* @__PURE__ */ jsx(
                "span",
                {
                  style: {
                    minWidth: "36px",
                    textAlign: "right",
                    fontSize: "13px",
                    color: "#444",
                    fontVariantNumeric: "tabular-nums"
                  },
                  children: rankingWeights[key].toFixed(2)
                }
              )
            ] }, key))
          ] })
        ]
      }
    )
  ] });
};
export {
  DevOptionsPanel as default
};
//# sourceMappingURL=DevOptionsPanel.js.map
